var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "buttons"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showToTop,
      expression: "showToTop"
    }],
    staticClass: "button blur go-to-top iconfont icon-fanhuidingbu",
    attrs: {
      "title": "返回顶部"
    },
    on: {
      "click": _vm.scrollToTop
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showCommentBut,
      expression: "showCommentBut"
    }],
    staticClass: "button blur go-to-comment iconfont icon-pinglun",
    attrs: {
      "title": "去评论"
    },
    on: {
      "click": _vm.scrollToComment
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button blur theme-mode-but iconfont icon-zhuti",
    attrs: {
      "title": "主题模式"
    },
    on: {
      "mouseenter": function ($event) {
        _vm.showModeBox = true;
      },
      "mouseleave": function ($event) {
        _vm.showModeBox = false;
      },
      "click": function ($event) {
        _vm.showModeBox = true;
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "mode"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showModeBox,
      expression: "showModeBox"
    }],
    ref: "modeBox",
    staticClass: "select-box",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      },
      "touchstart": function ($event) {
        $event.stopPropagation();
      }
    }
  }, _vm._l(_vm.modeList, function (item) {
    return _c('li', {
      key: item.KEY,
      staticClass: "iconfont",
      class: [item.icon, {
        active: item.KEY === _vm.currentMode
      }],
      on: {
        "click": function ($event) {
          return _vm.toggleMode(item.KEY);
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]);
  }), 0)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };